<template>
  <v-container fluid fill-height>
    <v-content class="home-page pt-12 mt-12">
      <v-row
        align="start"
        no-gutters
        justify-lg="start"
        justify-md="start"
        justify-sm="start"
      >
        <v-col sm="12" md="4" lg="4" class="d-flex flex-column ml-4 mr-4">
          <v-avatar id="avatar" color="#424242" size="200" class="ml-12">
            <img src="../assets/me.jpg" />
          </v-avatar>

          <v-card flat id="main">
            <v-col class="d-flex flex-grow-0 flex-shrink-0 mt-8">
              <v-text class="font-weight-black text-uppercase">
                <h2>Damon Bonner</h2>
              </v-text>
            </v-col>

            <v-card-subtitle
              class="d-flex flex-grow-0 flex-shrink-0 justify-start mt-auto pt-0"
            >
              <v-text class="d-flex justify-start subtitle-1 text-uppercase">
                damonjbonner@gmail.com
              </v-text>
            </v-card-subtitle>

            <!-- <v-col
            class="d-flex flex-column flex-grow-0 flex-shrink-0 justify-start mt-auto pl-0"
          >-->
            <v-divider class="mt-2" role="presentation" light></v-divider>
            <!-- </v-col>-->
            <v-col
              class="d-flex flex-column flex-grow-0 flex-shrink-0 justify-start mt-auto pl-0"
            >
              <v-card flat id="about">
                <v-card-title
                  class="text-justify font-weight-black subtitle-1 text-uppercase"
                >
                  About
                </v-card-title>

                <v-text class="text-justify body-1">
                  <p class="text-justify ml-4 mr-4 body-1">
                    <strong>Enterprise Cyber Security Analyst</strong>
                  </p>
                </v-text>
              </v-card>
            </v-col>

            <v-divider class="mt-8" role="presentation" light></v-divider>

            <v-flex class="d-flex justify-start mt-8">
              <v-btn icon href="https://github.com/rizingson" target="_blank">
                <v-icon class="pa-2">mdi-github</v-icon>
              </v-btn>

              <v-btn
                icon
                href="https://www.facebook.com/damon.bonner.33"
                target="_blank"
              >
                <v-icon class="pa-2">mdi-facebook</v-icon>
              </v-btn>

              <v-btn
                icon
                href="https://www.instagram.com/rizing_son/?hl=en"
                target="_blank"
              >
                <v-icon class="pa-2">mdi-instagram</v-icon>
              </v-btn>

              <v-btn
                icon
                href="https://www.linkedin.com/in/damon-bonner-9a5579178/"
                target="_blank"
              >
                <v-icon class="pa-2">mdi-linkedin</v-icon>
              </v-btn>

              <v-btn icon href="mailto: damonjbonner@gmail.com">
                <v-icon class="pa-2">mdi-email</v-icon>
              </v-btn>
            </v-flex>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
        <v-col id="more" sm="11" md="6" class="ml-4 mt-2 mr-4">
          <router-view />
        </v-col>
      </v-row>
    </v-content>
  </v-container>
</template>

<script>
export default {
  name: "Home"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#about,
#main {
  background-color: whitesmoke;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
